__turbopack_context__.v({
  "playBtnOverlay": "VideoCard-module-scss-module__hj0Hlq__playBtnOverlay",
  "playing": "VideoCard-module-scss-module__hj0Hlq__playing",
  "testimonialCard": "VideoCard-module-scss-module__hj0Hlq__testimonialCard",
  "testimonialItem": "VideoCard-module-scss-module__hj0Hlq__testimonialItem",
  "testimonialName": "VideoCard-module-scss-module__hj0Hlq__testimonialName",
  "testimonialThumbnail": "VideoCard-module-scss-module__hj0Hlq__testimonialThumbnail",
  "testimonialVideo": "VideoCard-module-scss-module__hj0Hlq__testimonialVideo",
  "w100": "VideoCard-module-scss-module__hj0Hlq__w100",
});
